const escapeSingleQuotes = str => str.replace(/'/g, "\\'")

export default escapeSingleQuotes
